"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _textInputData = require("../constants/textInputData");
var _jsxRuntime = require("react/jsx-runtime");
const styleOverrides = {
  inputRoot: ({
    theme
  }) => ({
    [`&[class*="${_material.filledInputClasses.root}"]`]: {
      paddingTop: 0,
      paddingLeft: theme.spacing(2),
      '& input': {
        padding: '12.5px 0'
      }
    }
  }),
  paper: ({
    theme
  }) => ({
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    boxShadow: 'none',
    transition: 'none'
  }),
  listbox: ({
    theme
  }) => ({
    [`& .${_material.autocompleteClasses.option}`]: {
      fontSize: theme.typography.body2.fontSize,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 10,
      paddingRight: 12
    },
    [`& .${_material.autocompleteClasses.option}::after`]: {
      content: '""',
      flexShrink: 0,
      display: 'block',
      overflow: 'hidden',
      width: '24px',
      height: '24px',
      background: 'transparent'
    },
    [`& .${_material.autocompleteClasses.option}.${_material.autocompleteClasses.focused}, & .${_material.autocompleteClasses.option}:focus`]: {
      backgroundColor: theme.palette.primary.light
    },
    [`& .${_material.autocompleteClasses.option}.${_material.menuItemClasses.focusVisible}`]: {
      backgroundColor: theme.palette.primary.light
    },
    [`& .${_material.autocompleteClasses.option}:hover`]: {
      backgroundColor: theme.palette.primary.light
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"]::after`]: {
      fill: theme.palette.success.main,
      content: _textInputData.selectedMark
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"].${_material.autocompleteClasses.option}[aria-selected="true"]`]: {
      backgroundColor: 'transparent'
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"].${_material.autocompleteClasses.focused}, & .${_material.autocompleteClasses.option}[aria-selected="true"]:focus`]: {
      backgroundColor: 'transparent'
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"].${_material.autocompleteClasses.option}[aria-selected="true"]:hover`]: {
      backgroundColor: theme.palette.primary.light
    }
  }),
  option: {}
};
const defaultProps = {
  clearIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
    fontSize: "small"
  }),
  popupIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
    fontSize: "medium"
  })
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
